export const PlaceArTreasureSTep = {
  DISPLAY: 'display',
  LOCATION: 'location',
  PRIZE: 'prize',
  PRIZE_TYPE: 'prize_type',
  AVAILABILITY: 'availability',
  REVIEW: 'review',
  SUBMITTED: 'submitted',
};

export const TreasureRewardType = {
  QrCode: 'QrCode',
  PromoCode: 'PromoCode',
  ActualProduct: 'ActualProduct',
};

export const TreasureRewardTypeLabel = {
  QrCode: 'Qr Code',
  PromoCode: 'Promotional Code',
  ActualProduct: 'Product',
};

export const TreasureCampaignType = {
  ArCoin: 'ArCoin',
  ArOwnLogo: 'ArOwnLogo',
  ArAnimator: 'ArAnimator',
};

export const TreasureCampaignTypeLabel = {
  ArCoin: 'Ar Coin',
  ArOwnLogo: 'Ar Own Logo',
  ArAnimator: 'Ar Animator',
};

export const TreasureCountry = {
  ALL: 'All',
  USA: 'USA',
  CANADA: 'Canada',
  UK: 'UK',
  GERMANY: 'Germany',
  FRANCE: 'France',
  //...
};

export const TreasureDefaultGenerateArAnimatorPoints =
  process.env.REACT_APP_TREASURE_DEFAULT_GENERATE_AR_ANIMATOR_POINTS || 5;
